import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const OneTimeLinkError = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Paper
            elevation={3}
            sx={{
                padding: 4,
                maxWidth: 500,
                textAlign: 'center',
                borderRadius: 2
            }}
        >
            <ErrorOutlineIcon sx={{ fontSize: 60, color: 'error.main' }} />

            <Typography variant="h2" fontWeight="bold" gutterBottom>
                {t('OneTimeLinkErrorTitle')}
            </Typography>

            <Typography variant="body1" sx={{ fontSize: '20px' }} gutterBottom>
                {t('OneTimeLinkErrorDescription')}
            </Typography>

            <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                {t('OneTimeLinkErrorSolution')}
            </Typography>

            <Button variant="contained" onClick={() => navigate('/join')} color="primary" fullWidth sx={{ mb: 2 }}>
                {t('GoToMembershipForm')}
            </Button>
        </Paper>
    );
};

export default OneTimeLinkError;
